/* NL Our Story — tabs, philosophy strips, timeline, awards filter */
(function(){
  function init(root){
    if(root.__nlStory) return; root.__nlStory = true;
    var tabs = {}, panels = {}, order = [];
    root.querySelectorAll('[role=tab]').forEach(function(t){ var k=t.getAttribute('data-tab'); order.push(k); tabs[k]=t; });
    root.querySelectorAll('[data-panel]').forEach(function(p){ panels[p.getAttribute('data-panel')]=p; });
    var tabbar = root.querySelector('[data-tabbar]'), ind = root.querySelector('[data-ind]');
    var hero = root.querySelector('.about-hero');
    var current = order[0];

    function hdrH(){ var h=document.querySelector('header.main-header'); return h ? h.offsetHeight : 0; }
    function setVars(){ root.style.setProperty('--tabs', tabbar.offsetHeight+'px'); }
    function moveInd(){ var t=tabs[current]; if(!t||!ind) return; ind.style.setProperty('--x', t.offsetLeft+'px'); ind.style.setProperty('--w', t.offsetWidth+'px'); }

    var track = root.querySelector('[data-tl-track]'), prev = root.querySelector('[data-tl-prev]'), next = root.querySelector('[data-tl-next]'), bar = root.querySelector('[data-tl-bar]');
    function tlUpdate(){
      if(!track) return;
      var max = track.scrollWidth - track.clientWidth, pos = track.scrollLeft;
      if(prev) prev.disabled = pos <= 4;
      if(next) next.disabled = pos >= max - 4;
      var p = max > 0 ? (track.clientWidth/track.scrollWidth) + (pos/max)*(1 - track.clientWidth/track.scrollWidth) : 1;
      if(bar) bar.style.setProperty('--p', Math.round(p*100)+'%');
    }

    function activate(key, opts){
      opts = opts || {};
      if(order.indexOf(key) < 0) key = order[0];
      current = key;
      order.forEach(function(k){
        var on = k===key;
        tabs[k].setAttribute('aria-selected', on);
        tabs[k].tabIndex = on ? 0 : -1;
        if(panels[k]){ panels[k].hidden = !on; panels[k].classList.toggle('enter', on); }
      });
      moveInd();
      var t = tabs[key], list = t.parentElement;
      list.scrollTo({ left: t.offsetLeft - (list.clientWidth - t.offsetWidth)/2, behavior:'smooth' });
      if(opts.updateHash !== false){ try{ history.replaceState(null,'','#'+key); }catch(e){} }
      if(opts.scroll && hero){
        var top = hero.getBoundingClientRect().bottom + window.pageYOffset - hdrH();
        window.scrollTo({ top: top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      if(key==='timeline') requestAnimationFrame(tlUpdate);
    }

    order.forEach(function(k,i){
      tabs[k].addEventListener('click', function(){ activate(k,{scroll:true}); });
      tabs[k].addEventListener('keydown', function(e){
        var n=null;
        if(e.key==='ArrowRight') n=order[(i+1)%order.length];
        if(e.key==='ArrowLeft') n=order[(i-1+order.length)%order.length];
        if(e.key==='Home') n=order[0];
        if(e.key==='End') n=order[order.length-1];
        if(n){ e.preventDefault(); activate(n,{scroll:false}); tabs[n].focus(); }
      });
    });
    root.querySelectorAll('[data-goto]').forEach(function(b){ b.addEventListener('click', function(){ activate(b.getAttribute('data-goto'),{scroll:true}); }); });
    window.addEventListener('hashchange', function(){ var k=location.hash.replace('#',''); if(order.indexOf(k)>-1) activate(k,{updateHash:false,scroll:true}); });
    window.addEventListener('resize', function(){ setVars(); moveInd(); tlUpdate(); });
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ setVars(); moveInd(); });

    /* philosophy strips: single-open */
    var strips = root.querySelectorAll('.strip');
    strips.forEach(function(s){ s.addEventListener('click', function(){ strips.forEach(function(o){ o.setAttribute('aria-expanded', o===s?'true':'false'); }); }); });

    /* timeline */
    if(track){
      var step = function(dir){ var it=track.querySelector('.tl-item'); if(it) track.scrollBy({ left: dir*it.offsetWidth, behavior:'smooth' }); };
      if(prev) prev.addEventListener('click', function(){ step(-1); });
      if(next) next.addEventListener('click', function(){ step(1); });
      track.addEventListener('scroll', tlUpdate, {passive:true});
      track.addEventListener('keydown', function(e){ if(e.key==='ArrowRight'){ e.preventDefault(); step(1);} if(e.key==='ArrowLeft'){ e.preventDefault(); step(-1);} });
      var down=false, sx=0, sl=0;
      track.addEventListener('pointerdown', function(e){ if(e.pointerType!=='mouse') return; down=true; sx=e.clientX; sl=track.scrollLeft; track.classList.add('drag'); });
      window.addEventListener('pointermove', function(e){ if(down) track.scrollLeft = sl-(e.clientX-sx); });
      window.addEventListener('pointerup', function(){ if(!down) return; down=false; track.classList.remove('drag'); });
    }

    /* awards filter */
    var chips = root.querySelectorAll('.chip'), rows = root.querySelectorAll('[data-award-list] .award');
    chips.forEach(function(c){ c.addEventListener('click', function(){
      var f=c.getAttribute('data-f');
      chips.forEach(function(o){ o.setAttribute('aria-pressed', o===c?'true':'false'); });
      rows.forEach(function(r){ r.hidden = !(f==='all' || r.getAttribute('data-k')===f); });
    }); });

    setVars();
    var h = location.hash.replace('#','');
    activate(order.indexOf(h)>-1 ? h : order[0], {updateHash:false});
    tlUpdate();
  }
  function boot(){ document.querySelectorAll('[data-nl-story]').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
